module.exports = __webpack_public_path__ + "static/media/accountbold.823f5d29.png";